import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './SubmitFinePrint.module.css';

/**
 * A component that displays the fine print for the submit button.
 * Note: this is not in use for ProductOrderForm.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.payoutDetailsWarning] - The payout details warning
 * @param {boolean} [props.isOwnListing] - Whether the listing is owned by the current user
 */
const SubmitFinePrint = ({ payoutDetailsWarning, isOwnListing }) => {
  // Drivelo: no "You won't be charged yet" line. Stripe takes the payment when the request is
  // sent, so the template's promise isn't true here.
  if (!payoutDetailsWarning && !isOwnListing) {
    return null;
  }
  return (
    <p className={css.finePrint}>
      {payoutDetailsWarning ? (
        payoutDetailsWarning
      ) : (
        <FormattedMessage id="OrderPanel.ownListing" />
      )}
    </p>
  );
};

export default SubmitFinePrint;
